import { Component, Vue } from 'vue-property-decorator';
import store from '@/pages/profile/store';

@Component
export default class IsChildApprovedMixin extends Vue {
  get id() {
    return store.state.id;
  }

  get children() {
    const { user } = this.$store.state;
    if (!user || !user.children) return [];
    return user.children;
  }

  get isApproved() {
    const { children, id } = this;
    if (!children.length || !id.length) return false;
    const child = children.find((item: any) => item.id === id);
    return child && child.is_approved;
  }

  childTutoredId(kid: string): string {
    const { tutored_id } = this.children.find(
      ({ id }: { id: string }) => id === kid,
    );

    return tutored_id ? tutored_id : '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/isChildApprovedMixin.ts